/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number5Dark = () => (
	<>
		<circle cx="16" cy="16" r="16" fill="#002855" />
		<path
			d="M15.4125 25.245C11.745 25.245 9.375 23.775 9.375 21.51C9.375 20.43 10.065 19.5825 10.7475 19.215C10.8 19.185 10.86 19.17 10.9275 19.17H13.2525C13.365 19.17 13.4775 19.2225 13.545 19.3125C13.6125 19.4025 13.6425 19.5225 13.6125 19.635C13.5225 20.01 13.4325 20.43 13.4325 20.9625C13.4325 22.1625 13.8075 23.5875 15.6 23.5875C17.055 23.5875 17.9625 22.5975 17.9625 21.0075C17.9625 18.555 15.675 17.3475 10.965 17.325C10.8525 17.325 10.755 17.2725 10.68 17.19C10.6125 17.1075 10.575 16.995 10.5975 16.89L12.0825 7.725C12.1125 7.545 12.27 7.41 12.45 7.41H18.765C19.47 7.41 19.53 7.41 19.9425 6.585C20.0025 6.4575 20.1375 6.375 20.28 6.375H21.0975C21.21 6.375 21.3075 6.42 21.3825 6.5025C21.45 6.585 21.4875 6.6975 21.465 6.8025L20.7675 11.265C20.7375 11.445 20.58 11.58 20.4 11.58H13.2825L13.005 13.155C18.915 13.2075 21.9075 15.3 21.9075 19.3875C21.9075 22.8825 19.2975 25.2375 15.4125 25.2375V25.245Z"
			fill="white"
		/>
	</>
);

export default Number5Dark;
